<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<div style="display: flex;flex-direction: row;width: 100%;">
			<div style="overflow-x: auto; flex: 2;" id="custom-table-expand">
				<vs-table :sst="true" class="shadow-none border-none table-auto" stripe :data="myOrders" @sort="handleSort">
					<div slot="header" class="mb-12 w-full" style="align-items: center; display: flex;flex-direction: row;width: 100%;overflow-x: scroll;">
						<h4 class="font-bold">Đơn hàng</h4>
						<div class="" :key="`${upStatus}--1`" style="min-width: 100px; margin-left: 15px;">
							<vs-button title="Tìm theo khớp giá" class="font-bold ml-3 w-full" :color="'#626262'" :type="isAll ? 'filled' : 'border'" @click="filterByStatus(-1)">Tất cả</vs-button>
						</div>
						<div class="" :key="`${upStatus}-${idxStatus}`" v-for="(statusLabel, idxStatus) in statusList" style="min-width: 150px; margin-left: 15px;">
							<vs-button title="Tìm theo khớp giá" class="font-bold ml-3 w-full" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
						</div>
						<div class="" style="min-width: 100px; margin-left: 100px;">
							<vs-button title="Lọc dữ liệu" class="font-bold ml-3 w-full" :color="'#2B59B2'" :type="filterDialog ? 'filled' : 'border'" @click="applyFilterDialog()">Bộ lọc</vs-button>
						</div>
						<div class="" style="min-width: 100px; margin-left: 15px;">
							<vs-button title="Lọc dữ liệu" class="font-bold ml-3 w-full" :color="'#2B59B2'" :type="'border'" @click="toggleReportDialog(true)">Tải báo cáo</vs-button>
						</div>
					</div>
					<template slot="thead">
						<vs-th sort-key="id" style="min-width:80px;"><h6 class="uppercase font-bold">ID</h6></vs-th>
						<vs-th sort-key="id" style="min-width:80px;"><h6 class="uppercase font-bold">Mã</h6></vs-th>
						<vs-th sort-key="product_id" style="min-width:150px;"><h6 class="uppercase font-bold">Người mua</h6></vs-th>
						<vs-th sort-key="product_id" style="min-width:150px;"><h6 class="uppercase font-bold">Mặt hàng</h6></vs-th>
						<vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Đơn giá</h6></vs-th>
						<vs-th sort-key="quantity" style="min-width:60px;"><h6 class="uppercase font-bold">KL</h6></vs-th>
						<vs-th sort-key="created_at" style="min-width:115px;"><h6 class="uppercase font-bold">Ngày giao</h6></vs-th>
						<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">TTVĐ</h6></vs-th>
						<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">TTTT</h6></vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr, indextr)">
							<vs-td>
								<p class="word-break uppercase" :style="{color: (tr.type == 1) ? 'rgb(99, 186, 70)' : 'rgb(222, 0, 0)'}">
									#{{ tr.id }}
								</p>
							</vs-td>
							<vs-td :set="countBCT = getNewBCT(tr.matching_buy.shippings || [])">

								<p :class="{ 'word-break': 1, 'step-item-blink': countBCT ? 1 : 0, 'font-bold': countBCT ? 1 : 0 }">
									#{{ getValueByKey(tr, 'id') }} <sup title="Bộ chứng từ chưa tải" style="cursor: help; color: red; position: absolute;">{{countBCT}}</sup>
								</p>
							</vs-td>
							<vs-td >
								<p class="word-break">
									{{ getValueByKey(tr, 'cus_name') }}
								</p>
							</vs-td>
							<vs-td>
								<p class="word-break">
									{{ tr.product ? tr.product.name : '-' }}
								</p>
							</vs-td>
							<vs-td>
								<p :class="{ 'word-break': 1 }">
									{{ $helper.numFormat(tr.price) }}
								</p>
							</vs-td>
							<vs-td>
								<p :class="{ 'word-break': 1 }">
									{{ $helper.numFormat(tr.quantity) }} <sup title="Chênh lệch so với thực tế" v-if="tr.quantity_extra" style="cursor: help; color: rgb(210, 172, 36);position: absolute;"> {{(tr.quantity_extra > 0 ? '+' :'') + $helper.numFormat(tr.quantity_extra)}}</sup>
								</p>
							</vs-td>
							<vs-td :set="tmpShippings=getValueByKey(tr, 'shippings')">
								<p class="word-break uppercase">
									{{ $helper.momentFormatLocale(tmpShippings && tmpShippings.length ? tmpShippings[0].shipping_date : undefined) }}
								</p>
							</vs-td>
							<vs-td :set="statusDirective = $helper.getStatusAndDirective3(tr.status)">
								<p :class="{ 'word-break': 1 }">
									<label :class="statusDirective.directive">
										{{ statusDirective.name}}
									</label>
								</p>
							</vs-td>
							<vs-td :set="statusDirective = $helper.getStatusAndDirectiveBilling(tr.billing_status)">
								<p :class="{ 'word-break': 1 }">
									<label :class="statusDirective.directive">
										{{ statusDirective.name}}
									</label>
								</p>
							</vs-td>
							<template class="expand-user" slot="expand">
								<div class="con-expand-users w-full" style="padding-left: 20px">
									<template lang="html">
										<div>
											<vs-table :data="activeDataShippings[indextr]" class="shadow-none border-none table-auto">
												<template slot="thead">
													<vs-th>
													Số vận đơn
													</vs-th>
													<vs-th>
													Thời gian giao
													</vs-th>
													<vs-th>
													Loại cá
													</vs-th>
													<vs-th>
													Hóa đơn
													</vs-th>
													<vs-th>
													
													</vs-th>
												</template>

												<template slot-scope="{data}">
													<vs-tr :key="indextr" v-for="(shipping, indextr) in activeDataShippings[indextr]" >
														<vs-td>
															{{shipping.code}}
														</vs-td>
														<vs-td>
															{{$helper.momentFormatLocale(shipping.shipping_date)}}
														</vs-td>
														<vs-td :set="ketoanDetails = shipping.ketoan_detail || {}">
															<table>
																<thead>
																	<td>Loại</td>
																	<td>KL</td>
																	<td>Đơn giá</td>
																	<td>Thành tiền</td>
																</thead>
																<tbody>
																	<tr :key="loaiindex" v-for="(loaica, loaiindex) in loaiCaMap" v-if="ketoanDetails[loaica.id] > 0">
																		<td  v-if="ketoanDetails[loaica.id]">
																			{{loaica.name}}
																		</td>
																		<td  v-if="ketoanDetails[loaica.id]" class="text-right">
																			{{$helper.numFormat(ketoanDetails[loaica.id])}}
																		</td>
																		<td  v-if="ketoanDetails[loaica.id]" class="text-right">
																			{{$helper.numFormat(ketoanDetails[loaica.id+'_price'] || 0)}}
																		</td>
																		<td  v-if="ketoanDetails[loaica.id]" class="text-right">
																			{{$helper.numFormat(ketoanDetails[loaica.id+'_total'] || 0)}}
																		</td>
																	</tr>
																</tbody>
															</table>
														</vs-td>
														<vs-td :set="unc = getHoaDon(shipping)">
															<div style="width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" v-if="unc">
																{{unc.payment_no}}
															</div>
														</vs-td>
														<vs-td>
															<a	:style="{cursor: 'pointer', color: (shipping.billing && shipping.billing.status >= 1 ? '#2B59B2' : '#D4D4D4')}"
																@click="downloadChungTu(shipping)">{{shipping.downloaded ? 'Đã Tải BCT' : 'Tải BCT'}}</a>
														</vs-td>
													</vs-tr>
												</template>
											</vs-table>
										</div>
									</template>
								</div>
							</template>
						</vs-tr>
					</template>
				</vs-table>
				<div class="w-full center mt-4">
					<CbsPagination :total="total" v-model="page"></CbsPagination>
				</div>
			</div>

			<div style="flex: 1; min-width: 500px;">
				<!-- <AccountUncBB /> -->
				<AccountUncHistoryBB />
				<AccountUncHistoryBBR />
			</div>
		</div>
		<DialogFilters :isPopupActive="filterDialog" @closePopup="toggleFilterDialog" :seekingData="seekingData"/>
		<DialogAccountReport :isPopupActive="reportDialog" @closePopup="toggleReportDialog" :seekingData="seekingData"/>
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import AccountUncBB from "./AccountUncBB.vue";
import AccountUncHistoryBB from "./AccountUncHistoryBB.vue";
import AccountUncHistoryBBR from "./AccountUncHistoryBBR.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";
import DialogFilters from "./DialogFilters.vue";
import DialogAccountReport from "./DialogAccountReport.vue";
import * as _ from "lodash";
const CAC_LOAI_CA = [
	{id: 'khoi_luong_ca_y_300', name: 'Cá Y 300 up'},
	{id: 'khoi_luong_ca_y_400', name: 'Cá Y 400 up'},
	{id: 'khoi_luong_ca_y_500', name: 'Cá Y 500 up'},
	{id: 'khoi_luong_ca_chet_300', name: 'Cá chết 300 up'},
	{id: 'khoi_luong_ca_chet_400', name: 'Cá chết 400 up'},
	{id: 'khoi_luong_ca_chet_500', name: 'Cá chết 500 up'},
	{id: 'khoi_luong_ca_dat', name: 'Cá dạt'},
];

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		AccountUncBB,
		AccountUncHistoryBB,
		AccountUncHistoryBBR,
		KcsForm,
		ChooseSells,
		SellerRatingForm,
		DialogFilters,
		DialogAccountReport
	},
	data() {
		return {
			loaiCaMap: CAC_LOAI_CA,
			key: 0,
			activeDataShippings: [],
			activeDataShippings2: [],
			myOrders: [],
			reportDialog: false,
			filterDialog: false,
			isAll: false,
			statusList: [
				// {
				// 	id: 0,
				// 	name: window.innerWidth > 600 ? 'Đang chờ' : 'Đang chờ',
				// 	active: 0,
				// 	color: 'primary',
				// },
				{
					id: 1,
					name: window.innerWidth > 600 ? 'Đơn mua' : 'Đơn mua',
					active: 0,
					color: 'rgb(99, 186, 70)',
				},
				{
					id: 2,
					name: window.innerWidth > 600 ? 'Đơn bán' : 'Đơn bán',
					active: 0,
					color: 'rgb(222, 0, 0)',
				},
				// {
				// 	id: 128,
				// 	name: window.innerWidth > 600 ? 'Đã thanh toán' : 'Đã TT',
				// 	active: 0,
				// 	color: '#057FBB',
				// },
			],

			refresh: 0,
			sellerRatingDialog: false,
			sellerRatingData: {},
			shippingDialog: false,
			shippingData: {},
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: true,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,
			customerData: {},
			userToken: '',
			sellsDialog: false,
			sellsData: {},
			upStatus: Date.now()
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.myOrdersTotal / this.$store.state.moduleProduct.limit);
		},
	},
	methods: {
		getNewBCT(shippings) {
			let count = 0;
			for (let k in shippings) {
				if (shippings[k].billing && shippings[k].billing.status >= 1 &&!shippings[k].downloaded) {
					count++;
				}
			}
			return count ? ('+' + count) : '';
		},
		getHoaDon(shipping) {
			return shipping.paymentno || null;
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				// this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		sortedArray(arrays){
			return arrays.sort((a, b) => a.id - b.id );
		},
		downloadChungTu(shipping) {
			if (shipping && shipping.id) {
				this.$store.dispatch("moduleProduct/getShippingFileById", shipping.id).then(data => {
					// console.log('downloadChungTu: ', data);
					if (data) {
						window.location.href = data;
						// window.open(data, '_blank');
					} else {
						this.$helper.notifyWarning({
							context: this,
							options: {
								text: "Yêu cầu kế toán Agri Index cung cấp bộ chứng từ",
							},
						});
					}
				}).catch (error => {
					this.$helper.notifyError({ context: this, error });
				});
			} else {
				this.$helper.notifyWarning({
					context: this,
					options: {
						text: "Hãy chọn một vận đơn",
					},
				});
			}
		},
		async reportOrder() {
			let statuses = [];
			let isAll = false;
			this.statusList.map(status => {
				if (status.active) {
					if (status.id == -1) {
						isAll = true;
					}
					statuses.push(status.id);
				}
			});
			// console.log(this.statusList);
			this.filters.types = !isAll ? statuses : [];
			const payload = {
				download: 1,
				filters: this.filters,
				id: 0,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				sort: this.sort,
				allCompany: 1
			};
			try {
				let allData = await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				console.log('allData: ', allData);
				if (allData) {
					window.location.href = allData;
				}
				
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		seekingData(filters, state) {
			console.log(filters);
			this.filters = Object.assign(this.filters, filters);
			this.getGetUsers();
		},
		applyFilterDialog() {
			this.filterDialog = !this.filterDialog;
		},
		async getGetUsers() {
			this.$vs.loading();
			let statuses = [];
			let isAll = false;
			this.statusList.map(status => {
				if (status.active) {
					if (status.id == -1) {
						isAll = true;
					}
					statuses.push(status.id);
				}
			});
			// console.log(this.statusList);
			this.filters.types = !isAll ? statuses : [];
			// console.log('filters: ', this.filters);
			const payload = {
				filters: this.filters,
				id: 0,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				sort: this.sort,
				allCompany: 1
			};
			try {
				let allData = await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				// console.log('allData: ', allData);
				if (allData && allData.data) {
					let activeDataShippings = [];
					for (let k in allData.data) {
						let item = allData.data[k];//_.cloneDeep();
						if (item) {
							let newItem = _.cloneDeep(item);
							newItem.matching_buy = newItem.matching;
							activeDataShippings.push(newItem.matching_buy && newItem.matching_buy.shippings ? newItem.matching_buy.shippings : []);
							allData.data[k] = newItem;
						}
					}
					console.log('allData.data: ' ,allData.data);
					this.activeDataShippings = activeDataShippings;
					this.myOrders = allData.data;
					// this.detailUserDialogData = allData.data[0] || {};
					// this.refresh = this.detailUserDialogData ? this.detailUserDialogData.id : 0;
					// console.log('this.detailUserDialogData: ', this.detailUserDialogData.id);
				} else {
					this.myOrders = []
				}
				// this.toggleDetailSidebar(true);
				
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getValueByKey(order, key) {
			if (order.type == 1 && order.matching_buy) {
				return order.matching_buy[key] || '-';
			}
			if (order.type == 2 && order.matching) {
				return order.matching[key] || '-';
			}

			return '';
		},
		filterByStatus(idxStatus) {
			if (idxStatus == -1) {
				this.isAll = !this.isAll;
			} else {
				this.isAll = false;
			}
			this.statusList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (this.isAll) {
					status.active = 0;
				}
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getGetUsers();
		},
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/shipping-print/'+item.id+'?token='+this.userToken, '', 'height=800, width=800');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		onClickCancelOrder(id, event) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: 'Thực hiện hủy lệnh số #'+id,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.cancelOrder(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
			if (event) {
				event.preventDefault()
			}
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickSellerRating(data, event) {
			let matchingId = 0;
			let cusName = '';
			if (data.type == 2) {
				matchingId = data.matching.id || '';
				cusName = data.matching.cus_name || '';
			} else {
				matchingId = data.matching_buy.id || '';
				cusName = data.matching_buy.supplier_name || '';
			}
			this.sellerRatingData = {
				type: data.type,
				id: data.id,
				matchId: matchingId,
				buyer_name: cusName,
				rating: data.rating,
				rating_note: data.rating_note
			};
			this.sellerRatingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickShippingOrder(data, event) {
			this.shippingData = {
				id: data.matching.id
			};
			this.shippingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickChooseSells(data, event) {
			this.sellsData = {
				id: data.id,
				status: data.status,
			};
			this.sellsDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload);
			} catch (error) {
				console.log(error.message);
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},
	
		toggleShippingDialog(val = false) {
			this.shippingDialog = val;
		},
		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		toggleReportDialog(val = false) {
			this.reportDialog = val;
		},
		toggleFilterDialog(val = false) {
			this.filterDialog = val;
		},
		toggleSellerRatingDialog(val = false) {
			this.sellerRatingDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleSellsDialog(val = false) {
			this.sellsDialog = val;
			if (!val) {
				this.sellsData = {};
				this.getGetUsers();
			}
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, order, indextr) {
			this.activeDataShippings2[indextr] = this.activeDataShippings[indextr];
			// document.querySelector('#custom-table-expand tr.tr-expand').remove();
			// if (order && order.matching_buy && order.matching_buy.shippings) {
			// 	this.activeDataShippings[indextr] = order.matching_buy.shippings;
			// }
			// this.key = Date.now();
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
	},
	created() {
		// Register Module UserManagement Module
		this.getGetUsers();
		// this.getProducts();
		this.getSuppliers();

		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { supplier_can_select = false, user_can_buy = false, user_can_sell = false } = permissions;
			if (user_can_buy) {
				this.canBuy = true;
			}
			if (user_can_sell) {
				this.canSell = true;
			}
			if (supplier_can_select) {
				this.canSelectSupplier = true;
			}
			this.userToken = token;
		}
		if (typeof localStorage === 'object' && localStorage) {
			let forceRelogin = localStorage.getItem('relogin');
			if (!forceRelogin) {
				localStorage.removeItem("accessToken");
				this.$acl.change("guest");
				localStorage.removeItem("userInfo");
				this.$router.push("/pages/login").catch(() => {});
				window.location = '/';
			}
		}
	},
};
</script>

<style lang="scss">
@keyframes fadeIn { 
  from { opacity: 0; } 
}
.step-item-blink {
	-webkit-animation: fadeIn 1s alternate infinite;
	-moz-animation: fadeIn 1s alternate infinite;
	animation: fadeIn 1s alternate infinite;

	// animation: fadeIn 1s infinite alternate;
}
.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
	.router-content label, .router-content span, .router-content p {
		font-size: 102% !important;
	}
</style>
